import { render, staticRenderFns } from "./DrawBill.vue?vue&type=template&id=628e52fa"
import script from "./DrawBill.vue?vue&type=script&lang=js"
export * from "./DrawBill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports